import React, { useState, useEffect } from "react";
import "./App.css";
import SearchBar from "./SearchBar.js";
import PageSelect from "./PageSelect.js";
import PageSizeDropdown from "./PageSizeDropdown.js";
import ContinentSelector from "./ContinentSelector.js";
import Table from "./Table.js";

function App() {
	/* Create state:
		- apiData: List containing dictionaries of countries from API.
		- searchQuery: The query parameter that should be added to &search=
		- pageNumber: The page that is requested
		*/

	const [apiData, setApiData] = useState(null);
	const [searchQuery, setSearchQuery] = useState();
	const [pageNumber, setPageNumber] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [ordering, setOrdering] = useState({key: "Country", asc: true});
	const [continents, setContinents] = useState([
		["Africa", "AF", true],
		["Asia", "AS", true],
		["Europe", "EU", true],
		["North America", "NA", true],
		["Oceania", "OC", true],
		["South America", "SA", true]]);

	useEffect(() => {
		// All parameters are appended to this URL.
		let apiQuery = "https://dhis2-app-course-api.ifi.uio.no/api?";

		// If searchQuery isn't empty add &search=searchQuery to the API request.
		if (searchQuery) {
			apiQuery += "&search=" + searchQuery;
		}

		// Add the page size
		apiQuery += "&pageSize=" + pageSize;

		// Add what page we are requesting to the API request.
		apiQuery += "&page=" + pageNumber;

		// Add ordering.
		apiQuery += "&order=" + ordering.key + ":" +
			(ordering.asc ? "ASC" : "DESC");

		// Add filters.
		apiQuery += "&ContinentCode=" + continents.filter(x => x[2]).map(x => x[1]).join(",");

		// Query data from API.
		console.log("Querying: " + apiQuery);
		fetch(apiQuery)
			.then((results) => results.json())
			.then((data) => {
				setApiData(data);
			});
	}, [searchQuery, pageNumber, pageSize, ordering, continents]);

	// The API is weird. If we ask for a page which doesn't exist, the API returns
	// just the string "pager", rather than an object with any useful info.
	// Therefore, if we get the string "pager", set page number to 1.
	// This isn't the right way to handle navigating to an invalid page...
	// But returning the string "pager" isn't the right way for the API to
	// handle a request for an invalid page either.
	if (apiData === "pager") {
		if (pageNumber !== 1) {
			setPageNumber(1);
		}

		return (<div className="App">
			<h1>Country lookup</h1>
			Loading...
		</div>);
	}

	if (apiData === null) {
		return (<div className="App">
			<h1>Country lookup</h1>
			Loading...
		</div>);
	}

	return (<div className="App">
		<h1>Country lookup</h1>
		Page size: <PageSizeDropdown
			onChange={setPageSize}
			pageSize={pageSize} />
		<br />
		Page: <PageSelect
			onChange={setPageNumber}
			page={apiData.pager.page}
			pageCount={apiData.pager.pageCount} />
		<br />
		<SearchBar onChange={setSearchQuery} />
		<br />
		<ContinentSelector continents={continents} onChange={setContinents} />
		<br />
		<br />
		<Table
			apiData={apiData}
			ordering={ordering}
			setOrdering={setOrdering}/>
	</div>);
}

export default App;
